import Button from './DocsButton.vue';
import Badge from './DocsBadge.vue';
import Callout from './DocsCallout.vue';
import TabNav from './DocsTabNav.vue';
import Formulate from './DocsFormulate.vue';
import Table from './DocsTable.vue';
import Position from './DocsPosition.vue';

export const components = [
  { path: 'button', component: Button, label: 'Buttons' },
  { path: 'badge', component: Badge, label: 'Badge' },
  { path: 'callout', component: Callout, label: 'Callout' },
  { path: 'tabnav', component: TabNav, label: 'Tab Nav' },
  { path: 'formulate', component: Formulate, label: 'Formkit' },
  { path: 'table', component: Table, label: 'Table' },
  {
    path: 'editor',
    component: () => import('./DocsEditor.vue'),
    label: 'Editor',
  },
  {
    path: 'position',
    component: Position,
    label: 'Position',
  },
];
